import { convertToLocalDateTime } from "./dateUtility";

export const convertDate = (requestDate: Date[] | null | undefined) => {
  let singleDate;
  let rangeDate;
  if (
    requestDate != null &&
    (requestDate[0] !== undefined || requestDate[1] !== undefined)
  ) {
    singleDate = convertToLocalDateTime(Number(requestDate![0]));
    rangeDate = [
      convertToLocalDateTime(Number(requestDate![0])),
      convertToLocalDateTime(Number(requestDate![1])),
    ];
  }
  if (requestDate) {
    if (requestDate?.length > 1) {
      return rangeDate;
    } else {
      return singleDate;
    }
  }
};
